import { render, staticRenderFns } from "./section6.vue?vue&type=template&id=f63a7a90&scoped=true"
import script from "./section6.vue?vue&type=script&lang=js"
export * from "./section6.vue?vue&type=script&lang=js"
import style0 from "./section6.vue?vue&type=style&index=0&id=f63a7a90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63a7a90",
  null
  
)

export default component.exports